export default __webpack_public_path__ + "static/media/youtube_home.600d5755.png";